var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('s-cabecalho'),_c('s-sobre'),_c('s-areas-de-atuacao'),_c('s-portfolio'),_c('s-equipe'),_c('s-rodape')],1)}
var staticRenderFns = []

export { render, staticRenderFns }